import { Formik } from 'formik';
import { Button } from 'components/Button/Button';
import { useResetPasswordVM } from './useResetPasswordVM';
import logo from 'assets/images/logo-colored.svg';

interface ResetPasswordFormValues {
    password: string;
    confirm_password: string;
}

export const ResetPassword: React.FC = () => {
    const { handleResetPassword, resetPasswordErrorMessage, handleBackToLogin, resetPasswordMode } = useResetPasswordVM();

    return (
        <div id="reset-password">
            <div className="reset-password-wrapper">
                <img src={logo} className="logo" />
                <div className="reset-password-form">
                    {resetPasswordMode === 'form' ? (
                        <Formik<ResetPasswordFormValues>
                            initialValues={{
                                password: '',
                                confirm_password: ''
                            }}
                            onSubmit={async (
                                values: ResetPasswordFormValues,
                                { setSubmitting }: { setSubmitting: (isSubmitting: boolean) => void }
                            ) => {
                                const { password, confirm_password } = values;
                                await handleResetPassword(password, confirm_password);
                                setSubmitting(false);
                            }}
                        >
                            {({ values, errors, touched, handleChange, handleBlur, handleSubmit, isSubmitting }) => (
                                <form onSubmit={handleSubmit} className="form">
                                    <h1 style={{marginBottom: 0}}>Définissez votre nouveau mot de passe</h1>
                                    <p style={{ textAlign: 'center', fontSize: '14px', color: '#666', marginBottom: '20px', marginTop: '0px' }}>
                                        Votre mot de passe doit contenir au moins 8 caractères, une lettre majuscule, une lettre minuscule et un chiffre.
                                    </p>
                                    <input
                                        type="password"
                                        name="password"
                                        placeholder="Nouveau mot de passe"
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                        value={values.password}
                                        required
                                    />
                                    {errors.password && touched.password && errors.password}
                                    <input
                                        type="password"
                                        name="confirm_password"
                                        placeholder="Confirmer le mot de passe"
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                        value={values.confirm_password}
                                        required
                                    />
                                    {errors.confirm_password && touched.confirm_password && errors.confirm_password}
                                    {resetPasswordErrorMessage && <p style={{ textAlign: 'center' }} className="api-error">{resetPasswordErrorMessage}</p>}
                                    <Button label="Modifier mon mot de passe" variant="dark" type="submit" disabled={isSubmitting} />
                                    <span onClick={handleBackToLogin}>Retour à la page de connexion</span>
                                </form>
                            )}
                        </Formik>
                    ) : (
                        <div className="reset-password-success">
                            <h1>Mot de passe modifié</h1>
                            <p>Votre mot de passe a été modifié avec succès. Vous pouvez désormais vous connecter.</p>
                            <Button label="Retour à la connexion" variant="dark" onClick={handleBackToLogin} />
                        </div>
                    )}
                </div>
                {resetPasswordMode === 'form' && <span onClick={handleBackToLogin}>Retour à la connexion</span>}
            </div>
        </div>
    );
};
